import { Root, Track, Range, Thumb } from '@radix-ui/react-slider';
import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const StyledRoot = styled(Root)`
  position: relative;
  display: flex;
  align-items: center;
  user-select: none;
  touch-action: none;
  width: 100%;
  &[data-orientation='horizontal'] {
    height: ${spacing.base};
    padding-top: ${spacing.double};
  }
  &[data-orientation='vertical'] {
    flex-direction: column;
    width: ${spacing.base};
    height: 100px;
  }
`;

export const StyledTrack = styled(Track)`
  background-color: ${colors.grey15};
  position: relative;
  flex: 1 0 100%;
  border-radius: 9999px;
  &[data-orientation='horizontal'] {
    height: ${spacing.quarter};
  }
  &[data-orientation='vertical'] {
    width: ${spacing.quarter};
  }
`;

export const SliderRange = styled(Range)`
  background-color: ${colors.green100};
  border-radius: 9999px;
  height: 100%;
  position: absolute;
  &[data-disabled] {
    background-color: ${colors.grey50};
  }
`;

export const SliderThumb = styled(Thumb)`
  display: block;
  width: ${spacing.base};
  height: ${spacing.base};
  background-color: ${colors.white};
  border: ${spacing.eighth} solid ${colors.green100};
  border-radius: ${spacing.base};
  &[data-disabled] {
    background-color: ${colors.grey50};
    border-color: ${colors.grey50};
  }
  &:hover:not([data-disabled]) {
    background-color: ${colors.green100};
  }
  &:focus:not([data-disabled]) {
    outline: none;
    :before {
      border-radius: 100%;
      border: ${spacing.single} solid ${colors.green100};
      content: '';
      display: block;
      inset: -${pxToRem(3)};
      position: absolute;
      z-index: 0;
    }
  }
`;

export const Legend = styled.div`
  margin-top: ${spacing.half};
  display: flex;
  justify-content: space-between;
`;
